module.exports = __webpack_public_path__ + "img/keyboard_key_3.07ab07e1.png";